import filter from "@/api/filter";
// 对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
export const config = {
  data() {
      return {
          searchParams: {},
          columns: []
      };
  },
  methods: {
    getColumns() {
      let idx = ''
      let columns1 =  [
        {
          type: 'selection',
          width: 60,
          fixed: "left",
          align: 'center'
        },
        {
          title: "保单号",
          align: "center",
          fixed: "left",
          key: "policyNo",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "保险公司",
          align: "center",
          key: "companyName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "保险产品",
          align: "center",
          key: "productName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "险种名称",
          align: "center",
          key: "productTypeName",
          minWidth: 280,
          tooltip: true,
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if (params.row.insureTime) {
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "生效日期",
          align: "center",
          key: "effectTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.effectTime) {
              const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "回执回销日期",
          align: "center",
          key: "receiptDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.receiptDate) {
              const value = filter.filterTime(params.row.receiptDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "回访日期",
          align: "center",
          key: "revisitDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.revisitDate) {
              const value = filter.filterTime(params.row.revisitDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "犹豫止期",
          align: "center",
          key: "hesitateDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.hesitateDate) {
              const value = filter.filterTime(params.row.hesitateDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "保障期",
          align: "center",
          key: "guaranteeValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期",
          align: "center",
          key: "payValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期次",
          align: "center",
          key: "commissionPeriods",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "保费",
          align: "center",
          key: "fee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "标保",
          align: "center",
          key: "foldFyb",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            const commissionType = params.row.commissionType;
            const activityName = params.row.activityName;
            if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              if(activityName) {
                return (
                  <span>限时加费活动
                    <Tooltip
                      trigger="hover"
                      content="content"
                      transfer={true}
                    >
                      <span class="tip-icon">?</span>
                      <div slot="content">
                        <div>{ activityName }</div>
                        <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
                      </div>              
                    </Tooltip>
                  </span>
                )
              }else{
                return (
                  <span>限时加费活动
                    <Tooltip
                      trigger="hover"
                      content="content"
                      transfer={true}
                    >
                      <span class="tip-icon">?</span>
                      <div slot="content">-</div>              
                    </Tooltip>
                  </span>
                )
              }
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费</span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: "费率",
          align: "center",
          key: "commission",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            const commission = params.row.commission;
            if(Number(commission)){
              return <span>{commission}</span>; 
            }else{
              return <span>-</span>
            }
          },
        },
        {
          title: "费用",
          key: "commissionPrice",
          width: 150,
          align: "center",
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 2) {
              msg = '部分退保';
            } else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: "所属业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "出单团队",
          key: "groupName",
          width: 150,
          align: "center",
        },
        {
          title: "出单机构",
          key: "orgName",
          width: 150,
          align: "center",
        },
      ]

      let columns2 =  [
        {
          type: 'selection',
          width: 60,
          fixed: "left",
          align: 'center'
        },
        {
          title: "保单号",
          align: "center",
          fixed: "left",
          key: "policyNo",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "保险公司",
          align: "center",
          key: "companyName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "保险产品",
          align: "center",
          key: "productName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "险种名称",
          align: "center",
          key: "productTypeName",
          minWidth: 280,
          tooltip: true,
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if (params.row.insureTime) {
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "生效日期",
          align: "center",
          key: "effectTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.effectTime) {
              const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "保障期",
          align: "center",
          key: "guaranteeValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期",
          align: "center",
          key: "payValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "保单年度",
          align: "center",
          key: "commissionIndex",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期次",
          align: "center",
          key: "commissionPeriods",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "实收日期",
          align: "center",
          key: "actualReceiveTime",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.actualReceiveTime) {
              const value = filter.filterTime(params.row.actualReceiveTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "应收保费",
          align: "center",
          key: "receivableFee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "实收保费",
          align: "center",
          key: "actualFee",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if ((commissionType == 1||commissionType == 3)&&params.row.commissionIndex > 1){
              return <span>续期基础费用</span>;
            } else if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动</span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费</span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: "费率",
          align: "center",
          key: "commission",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            const commission = params.row.commission;
            if(Number(commission)){
              return <span>{commission}</span>; 
            }else{
              return <span>-</span>
            }
          },
        },
        {
          title: "费用",
          key: "commissionPrice",
          width: 150,
          align: "center",
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: "所属业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "出单团队",
          key: "groupName",
          width: 150,
          align: "center",
        },
        {
          title: "出单机构",
          key: "orgName",
          width: 150,
          align: "center",
        },
      ]
      if (this.statementData.reconciliationType == 1 || this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3) {
        this.columns = columns1
        if(this.statementData.reconciliationType == 1 || this.statementData.reconciliationType == 3){
          let idx = ''
          idx = this.columns.findIndex(item => item.key == 'foldFyb')
          this.columns.splice(idx, 1);
        }
      }else if(this.statementData.reconciliationType == 4 || this.statementData.reconciliationType == 5){
        this.columns = columns2
      }
    },
  }
};